import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { IBlock } from "../../../../../types/IBlock";
import { IContentfulRichTextResponse } from "../../../../../types/IContentfulRichText";
import "./styles.scss";
import { PanelWrapper } from "../../../../PanelWrapper";
import arrowForward from "./arrow-forward.svg";
import { redirect } from "../../../../../helpers/redirect";

export interface IPullOutBlocksPanelBetterV2Cards {
  blocks: IBlock[];
  content?: IContentfulRichTextResponse;
  headerAnchor?: string;
  title?: string;
}

export const PullOutBlocksPanelBetterV2Cards: React.FC<IPullOutBlocksPanelBetterV2Cards> = (props) => {
  const {
    blocks,
    title,
  } = props;
  const onBlockClick = (url: string) => {
    redirect(url || "/");
  };

  return (
    <PanelWrapper isBetterV2>
      <div className="pullOutBlocksPanelV2">
        {title
        && (
        <p className="pullOutBlocksPanelV2__title">
          {title}
        </p>
        )}
        <div className="blocksV2">
          {blocks.map((block, index) => (
            <button type="button" key={index} className="block-cardV2" onClick={() => onBlockClick(block.link!.url)}>
              <div className="block-cardV2__content">
                <p className="block-cardV2__title">{block.title}</p>
                <p className="block-cardV2__text">{block.content && renderRichText(block.content)}</p>
              </div>
              <img src={arrowForward} alt="arrow forward" className="block-cardV2__icon" />
            </button>
          ))}
        </div>
      </div>
    </PanelWrapper>
  );
};
